import React, { useEffect, useRef } from 'react';
interface Star {
  x: number;
  y: number;
  z: number;
  size: number;
  color: string;
}
export function Starfield() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const mouseRef = useRef({
    x: 0,
    y: 0,
    targetX: 0,
    targetY: 0
  });
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
    const stars: Star[] = [];
    const numStars = 800;
    const colors = ['#ffffff', '#e7ecff', '#06b6d4', '#6d28d9'];
    for (let i = 0; i < numStars; i++) {
      stars.push({
        x: Math.random() * width - width / 2,
        y: Math.random() * height - height / 2,
        z: Math.random() * 1000,
        size: Math.random() * 1.5 + 0.5,
        color: colors[Math.floor(Math.random() * colors.length)]
      });
    }
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
    };
    const handleMouseMove = (e: MouseEvent) => {
      mouseRef.current.targetX = (e.clientX - width / 2) * 0.05;
      mouseRef.current.targetY = (e.clientY - height / 2) * 0.05;
    };
    window.addEventListener('resize', handleResize);
    window.addEventListener('mousemove', handleMouseMove);
    let animationFrameId: number;
    const render = () => {
      ctx.fillStyle = '#03040a';
      ctx.fillRect(0, 0, width, height);
      // Smooth mouse interpolation
      mouseRef.current.x += (mouseRef.current.targetX - mouseRef.current.x) * 0.05;
      mouseRef.current.y += (mouseRef.current.targetY - mouseRef.current.y) * 0.05;
      const cx = width / 2;
      const cy = height / 2;
      stars.forEach(star => {
        star.z -= 0.5; // Drift towards camera
        if (star.z <= 0) {
          star.z = 1000;
          star.x = Math.random() * width - width / 2;
          star.y = Math.random() * height - height / 2;
        }
        const scale = 1000 / star.z;
        const px = cx + (star.x - mouseRef.current.x * (1000 - star.z) * 0.01) * scale;
        const py = cy + (star.y - mouseRef.current.y * (1000 - star.z) * 0.01) * scale;
        if (px >= 0 && px <= width && py >= 0 && py <= height) {
          ctx.beginPath();
          ctx.arc(px, py, star.size * scale * 0.5, 0, Math.PI * 2);
          ctx.fillStyle = star.color;
          // Add glow to closer stars
          if (star.z < 300) {
            ctx.shadowBlur = 10;
            ctx.shadowColor = star.color;
          } else {
            ctx.shadowBlur = 0;
          }
          ctx.fill();
        }
      });
      // Draw nebula clouds
      const gradient1 = ctx.createRadialGradient(cx * 0.5, cy * 0.5, 0, cx * 0.5, cy * 0.5, Math.max(width, height) * 0.8);
      gradient1.addColorStop(0, 'rgba(109, 40, 217, 0.08)');
      gradient1.addColorStop(1, 'transparent');
      ctx.fillStyle = gradient1;
      ctx.fillRect(0, 0, width, height);
      const gradient2 = ctx.createRadialGradient(cx * 1.5, cy * 1.5, 0, cx * 1.5, cy * 1.5, Math.max(width, height) * 0.6);
      gradient2.addColorStop(0, 'rgba(6, 182, 212, 0.06)');
      gradient2.addColorStop(1, 'transparent');
      ctx.fillStyle = gradient2;
      ctx.fillRect(0, 0, width, height);
      animationFrameId = requestAnimationFrame(render);
    };
    render();
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  return <canvas ref={canvasRef} className="fixed inset-0 w-full h-full pointer-events-none z-0" style={{
    background: '#03040a'
  }} data-id="element-167" />;
}